import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { REQUESTPASSWORDRESET } from '../config/setup/setup';
import ErrorTrackingService from './errorTrackingService';
import httpCommonHeaders from './httpCommonHeaders';

export const requestPasswordReset = async (email) => {
  try {
    return await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'POST',
      url: REQUESTPASSWORDRESET(email),
      validateStatus: (statusCode) => {
        return statusCode < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    ErrorTrackingService.logError(error);
  }
};

export const resetPassword = async (apiUrl, requestId, password) => {
  try {
    return await axios({
      cache: false,
      data: {
        passwordChange: { newPassword: password },
      },
      headers: httpCommonHeaders(),
      method: 'POST',
      url: `${apiUrl}?_xx_=${requestId}`,
      validateStatus: (statusCode) => {
        return statusCode < 500;
      },
      withCredentials: true,
    });
  } catch (error) {
    ErrorTrackingService.logError(error);

    return error;
  }
};
